import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

datadogRum.init({
  applicationId: environment.datadog_parameters.applicationId,
  clientToken: environment.datadog_parameters.clientToken,
  site: 'datadoghq.com',
  service: environment.datadog_parameters.service,
  env: environment.datadog_parameters.env,
  version: environment.datadog_parameters.version,
  sessionSampleRate: environment.datadog_parameters.sessionSampleRate,
  sessionReplaySampleRate: environment.datadog_parameters.sessionReplaySampleRate,
  trackBfcacheViews: environment.datadog_parameters.trackBfcacheViews,
  defaultPrivacyLevel: 'mask-user-input'
});

datadogRum.startSessionReplayRecording();

datadogLogs.init({
  clientToken: environment.datadog_parameters.clientToken,
  site: 'datadoghq.com',
  service: environment.datadog_parameters.service,
  env: environment.datadog_parameters.env,
  version: environment.datadog_parameters.version,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: "all",
  sessionSampleRate: environment.datadog_parameters.sessionSampleRate
});

datadogLogs.setGlobalContext(`{'appid': '${environment.datadog_parameters.applicationId}', 'businessservices': '${environment.datadog_parameters.service}'}`)

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

declare global {
  interface Window {
    stag(evento: string, eventType: string, params: object): void | Promise<any>
  }
}
